import state from '@/stores/metrics/state.js'
import mutations from '@/stores/metrics/mutations.js'
import actions from '@/stores/metrics/actions.js'

export default {
  state,
  mutations,
  actions
}
